import { render, staticRenderFns } from "./RateDerivation.vue?vue&type=template&id=1b077ca8"
import script from "./RateDerivation.vue?vue&type=script&lang=js"
export * from "./RateDerivation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports